/* MT desktop menu hover intent (2026-10-10, Andrew: "if i mouseover the menu, it's hard to find a way to
   close it ... Do 1-3").
   The theme (global.js <disclosure-menu>) opens a header mega menu the instant the pointer touches a top
   item and only closes it when the pointer leaves the whole item, panel included. Panels are full width and
   up to ~730px tall, so a pass-through on the way down to the page opens one and there's no easy way out.
   This file takes over ONLY the mouse enter/leave of header menus (details.header-menu__details) on mouse
   devices and reuses the theme's own open/close methods:
     1. open after the pointer rests 200ms on an item (a pass-through does nothing); switching from an
        open menu to a neighbor takes 120ms
     2. a 250ms grace period on leave, so small overshoots don't snap it shut
     3. Escape, a click outside, or scrolling the page closes it
   Keyboard (focus, Enter, Escape on focus), touch and click-to-navigate on the top item are untouched.
   Rollback: remove the script tag from sections/header.liquid. */
(function () {
  'use strict';
  if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var OPEN_DELAY = 200;
  var SWITCH_DELAY = 120;
  var CLOSE_DELAY = 250;
  var SCROLL_CLOSE_PX = 40;

  var openTimer = null;
  var closeTimer = null;
  var current = null;
  var scrollAtOpen = 0;

  function headerMenu(el) {
    if (!el || el.tagName !== 'DISCLOSURE-MENU') return null;
    var d = el.querySelector(':scope > details');
    return d && d.classList.contains('header-menu__details') ? el : null;
  }

  function close(menu) {
    if (!menu) return;
    if (typeof menu.hidePanel === 'function' && menu.details) menu.hidePanel(menu.details);
    else if (menu.details) menu.details.removeAttribute('open');
    if (current === menu) current = null;
  }

  function open(menu, evt) {
    if (current && current !== menu) close(current);
    clearTimeout(closeTimer);
    if (typeof menu.panelMouseEnter === 'function') menu.panelMouseEnter(evt);
    else if (menu.details) menu.details.setAttribute('open', '');
    current = menu;
    scrollAtOpen = window.scrollY || 0;
  }

  /* capture on document runs before the theme's own listeners on <disclosure-menu>; stopping the event
     here keeps the instant open/close from firing */
  document.addEventListener('mouseenter', function (e) {
    var menu = headerMenu(e.target);
    if (!menu) return;
    e.stopImmediatePropagation();
    clearTimeout(openTimer);
    if (current === menu) { clearTimeout(closeTimer); return; }
    openTimer = setTimeout(function () { open(menu, e); }, current ? SWITCH_DELAY : OPEN_DELAY);
  }, true);

  document.addEventListener('mouseleave', function (e) {
    var menu = headerMenu(e.target);
    if (!menu) return;
    e.stopImmediatePropagation();
    clearTimeout(openTimer);
    if (current !== menu) return;
    clearTimeout(closeTimer);
    closeTimer = setTimeout(function () { close(menu); }, CLOSE_DELAY);
  }, true);

  function closeNow() {
    clearTimeout(openTimer);
    clearTimeout(closeTimer);
    if (current) close(current);
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.key === 'Esc') {
      if (current) closeNow();
    }
  });

  document.addEventListener('pointerdown', function (e) {
    if (current && !current.contains(e.target)) closeNow();
  }, true);

  window.addEventListener('scroll', function () {
    if (current && Math.abs((window.scrollY || 0) - scrollAtOpen) > SCROLL_CLOSE_PX) closeNow();
  }, { passive: true });

  /* the page doesn't scroll while the pointer is over an open panel (it sits in the sticky header), so a
     wheel/trackpad scroll there means "I want the page": close, unless that spot in the menu can scroll
     itself (a tall panel on a short screen) */
  function canScroll(el, dy) {
    for (var n = el; n && n !== current && n !== document.body; n = n.parentElement) {
      var oy = getComputedStyle(n).overflowY;
      if ((oy === 'auto' || oy === 'scroll') && n.scrollHeight > n.clientHeight + 1) {
        if (dy > 0 ? n.scrollTop + n.clientHeight < n.scrollHeight - 1 : n.scrollTop > 0) return true;
      }
    }
    return false;
  }
  window.addEventListener('wheel', function (e) {
    if (!current || Math.abs(e.deltaY) < 4) return;
    if (current.contains(e.target) && canScroll(e.target, e.deltaY)) return;
    closeNow();
  }, { passive: true });
})();
